import React, {useContext, useEffect} from 'react';
import Sidebar from "../Sidebar";
import {Outlet, useLocation} from "react-router-dom";
import authContext from "../../AuthProvider/authContext";
import DashboardHeader from "./DashboardHeader";

const MainLayout = () => {
    const location = useLocation();
    const {getAuthenticatedUser} = useContext(authContext);

    useEffect(()=> {
        getAuthenticatedUser(true);
    },[]);

    return (
        <div className="d-flex">
            <Sidebar />
            <div className={"dashboard"}>
                <DashboardHeader/>
            <div className="dashboard-container">
                <Outlet/>
            </div>
            </div>
        </div>
    );
};

export default MainLayout;